import { DeleteOutlined } from '@ant-design/icons';
import type { MouseEvent } from 'react';
import { useWatch } from 'react-hook-form';

import Button from '~/shared/components/form-fields/button';
import { getPattern } from '~/shared/helpers/form-helpers';

import '~/shared/components/form-fields/items-list-field/items-list-field.scss';

type ItemsListFieldPropsType = {
  pattern: string;
  position1?: Record<string, unknown>;
  position2?: Record<string, unknown>;
  position3?: Record<string, unknown>;
  position4?: Record<string, unknown>;
  position5?: Record<string, unknown>;
  position6?: Record<string, unknown>;
  fields: Record<string, unknown>;
  navigation: Record<string, unknown>;
  t: (key: string, options: { ns: string[] }) => string;
};

const ItemsListField = (props: ItemsListFieldPropsType) => {
  const {
    control,
    config,
    value,
    append,
    getValues,
    name,
    onChange,
    index,
    setValue,
    suppressHydrationWarning,
    errors,
    watch,
    type,
  } = props;
  const { position6 } = config;

  useWatch({ control, name });

  return (
    <div className="items-list-field">
      <>
        {
          <div>
            <div>
              <div className="items-list-field__items">
                {getPattern({
                  ...props,
                  ...props?.config,
                  fieldConfig: {
                    name: name,
                  },
                  errors,
                  append,
                  watch,
                  control,
                  setValue,
                  getValues,
                })}
              </div>
              {position6 && (
                <div className="items-list-field__item-buttons">
                  {position6?.buttons?.map((item, index) => (
                    <Button
                      key={index}
                      onClick={
                        item.name === 'deleteIconButton'
                          ? (e: MouseEvent<HTMLInputElement>) => {
                              e.preventDefault();
                            }
                          : (e: MouseEvent<HTMLInputElement>) => {
                              e.preventDefault();
                            }
                      }
                    >
                      <DeleteOutlined />
                    </Button>
                  ))}
                </div>
              )}
            </div>
          </div>
        }
      </>
    </div>
  );
};

export default ItemsListField;
